import { atom } from 'recoil';

export const warehouseLayoutState = atom({
  key: 'warehouseLayoutState',
  default: { layout: null, loaded: false },
});

export const warehouseStorageConfigState = atom({
  key: 'warehouseStorageConfigState',
  default: { storageConfig: null, loaded: false },
});
